var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.889 6.479a2.48 2.48 0 1 1-4.959-.001 2.48 2.48 0 0 1 4.958-.001zm-1.103 9.73c.155-.09.324-.18.502-.276 1.084-.578 2.473-1.32 2.71-3.213 0-.488-.734-1.816-2.203-2.11-.935-.187-2.275.364-3.583 1.192a11.66 11.66 0 0 0-10.555-6.7C7.22 5.102 2 10.322 2 16.76c0 6.44 5.22 11.66 11.66 11.66 4.4 0 8.23-2.438 10.215-6.037.363.02.65-.09.8-.39.295-.588.262-1.272.166-1.92.271-.916.433-1.877.47-2.87.37-.337.867-.637 1.477-.993zm-6.67-.423c-.48 1.08-.522 2.247-.35 3.145A6.43 6.43 0 0 1 7.325 16.67a6.426 6.426 0 0 1 12.792-.883z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrn);
export default __webpack_public_path__ + "static/media/ORN.20fb5c6dbd3509f3ce5afafdbdb94a9f.svg";
export { ForwardRef as ReactComponent };